module.exports = __webpack_public_path__ + "assets/img/error.3ced2d4a.png";